import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';
import { useScrollReset } from './common/hooks';

// eslint-disable-next-line no-multi-assign, no-underscore-dangle
const _hsq = window._hsq = window._hsq || [];

const sendPageView = (pathname) => {
  _hsq.push(['setPath', pathname]);
  _hsq.push(['trackPageView']);
};

const RouteChangeListener = ({
  children,
}) => {
  const prevPathname = useRef();
  const { pathname } = useLocation();
  const history = useHistory();

  useScrollReset(pathname);

  useEffect(() => {
    sendPageView(pathname);
    history.listen(sendPageView);

    prevPathname.current = pathname;
  }, [pathname]);

  return (
    <>{children}</>
  );
};

RouteChangeListener.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default RouteChangeListener;
